import React from "react";
import PropTypes from "prop-types";

import { createModal } from "common/Modals";
import SVGIcon from "common/SVGIcon";

import MatchScoreInfo from "./MatchScoreInfo";

class MatchScoreModal extends React.PureComponent {
    static propTypes = {
        hideModal: PropTypes.func.isRequired,
        matchScore: PropTypes.number.isRequired,
    };

    render() {
        return (
            <div className="ws-modal ws-modal-tiny match-score-modal">
                <SVGIcon icon="close" onClick={this.props.hideModal} />
                <div className="ws-modal-body">
                    <MatchScoreInfo matchScore={this.props.matchScore} />
                </div>
                <div className="ws-modal-footer">
                    <p>
                        To improve your Match Score, answer questions from your homepage, or click
                        below!
                    </p>
                    <a className="btn btn-primary btn-large" href="/u/questions/">
                        Improve Match Score
                    </a>
                </div>
            </div>
        );
    }
}

export default createModal(MatchScoreModal);
